var __jsx = React.createElement;
import React from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var If = function If(_ref) {
  var condition = _ref.condition,
      children = _ref.children;
  return condition ? /*#__PURE__*/_jsx(_Fragment, {
    children: children
  }) : null;
};